/**
 * Venchy Assistant Mock Data
 * 
 * TODO: Remove this file after backend API implementation is complete.
 * These mocks are only for UI development and testing purposes.
 */

import { 
  IQuickActionButton, 
  ISuggestionItem, 
  IWelcomeExample,
  IActionCard
} from '../types/venchy.types';

/**
 * Quick action buttons configuration
 */
export const quickActionButtons: IQuickActionButton[] = [
  { id: 'search', icon: '🔍', labelKey: 'VENCHY_QUICK_SEARCH', promptKey: 'VENCHY_PROMPT_SEARCH' },
  { id: 'add', icon: '➕', labelKey: 'VENCHY_QUICK_ADD', promptKey: 'VENCHY_PROMPT_ADD' },
  { id: 'move', icon: '🔄', labelKey: 'VENCHY_QUICK_MOVE', promptKey: 'VENCHY_PROMPT_MOVE' },
  { id: 'stats', icon: '📊', labelKey: 'VENCHY_QUICK_STATS', promptKey: 'VENCHY_PROMPT_STATS' },
  { id: 'pending', icon: '⏱', labelKey: 'VENCHY_QUICK_PENDING', promptKey: 'VENCHY_PROMPT_PENDING' }
];

/**
 * Suggestion items for autocomplete
 */
export const suggestionItems: ISuggestionItem[] = [
  { 
    id: 'sug-1', 
    icon: '🔍', 
    textKey: 'VENCHY_SUGGESTION_FIND_TOMORROW',
    prompt: 'VENCHY_PROMPT_FIND_TOMORROW'
  },
  { 
    id: 'sug-2', 
    icon: '⏱', 
    textKey: 'VENCHY_SUGGESTION_PENDING',
    prompt: 'VENCHY_PROMPT_PENDING'
  },
  { 
    id: 'sug-3', 
    icon: '📊', 
    textKey: 'VENCHY_SUGGESTION_WEEKLY_COUNT',
    prompt: 'VENCHY_PROMPT_WEEKLY_COUNT'
  }
];

/**
 * Welcome screen examples
 */
export const welcomeExamples: IWelcomeExample[] = [
  { id: 'ex-1', textKey: 'VENCHY_EXAMPLE_FIND_TOMORROW', prompt: 'VENCHY_PROMPT_FIND_TOMORROW' },
  { id: 'ex-2', textKey: 'VENCHY_EXAMPLE_SHOW_PENDING', prompt: 'VENCHY_PROMPT_PENDING' },
  { id: 'ex-3', textKey: 'VENCHY_EXAMPLE_MONTHLY_COUNT', prompt: 'VENCHY_PROMPT_MONTHLY_COUNT' },
  { id: 'ex-4', textKey: 'VENCHY_EXAMPLE_MOVE_APPOINTMENTS', prompt: 'VENCHY_PROMPT_MOVE_ALL' }
];

/**
 * Mock pending appointments for demo
 */
export const mockPendingAppointments: IActionCard[] = [
  {
    id: 'apt-1',
    title: 'אבי מזרחי - מחר 10:00',
    badge: 'VENCHY_BADGE_PENDING',
    badgeType: 'warning',
    details: 'ד"ר רחל מזרחי | מאוחדת | חדר 3B',
    showButtons: true
  },
  {
    id: 'apt-2',
    title: 'דנה כהן - יום רביעי 14:00',
    badge: 'VENCHY_BADGE_PENDING',
    badgeType: 'warning',
    details: 'ד"ר משה כהן | כללית | חדר 1A',
    showButtons: true
  },
  {
    id: 'apt-3',
    title: 'רון ביטון - יום חמישי 16:00',
    badge: 'VENCHY_BADGE_PENDING',
    badgeType: 'warning',
    details: 'ד"ר דוד אברהם | פרטי | חדר 2B',
    showButtons: true
  }
];

/**
 * Mock available slots for demo
 */
export const mockAvailableSlots: IActionCard[] = [
  {
    id: 'slot-1',
    title: 'מחר 09:00 - ד"ר משה כהן',
    badge: 'VENCHY_BADGE_AVAILABLE',
    badgeType: 'success',
    details: 'חדר 1A | 60 דקות',
    showButtons: false
  },
  {
    id: 'slot-2',
    title: 'מחר 11:00 - ד"ר שרה לוי',
    badge: 'VENCHY_BADGE_AVAILABLE',
    badgeType: 'success',
    details: 'חדר 2B | 60 דקות',
    showButtons: false
  }
];

/**
 * Mock statistics response
 */
export const mockStatsResponse = {
  totalAppointments: 127,
  approved: 98,
  approvedPercent: 77,
  pending: 17,
  cancelled: 12,
  busiestTherapist: 'ד"ר משה כהן',
  busiestTherapistCount: 32,
  dominantInsurance: 'כללית',
  dominantInsurancePercent: 45
};
